var Theme = Theme || {};

Theme.MyInterests = (function ($) {
    let $body = $('body');
    let $noAccessModal = $('.manage-interests-modal-noaccess');
    let $interestsModal = $('.manage-interests-modal');
    let $successMsgSpan = $('#successMsg');
    let $errorMsgSpan = $('#errorMsg');

    return {
        init: _init
    };

    function _init() {
        openManageInterestsModal();
        openPaywallModal();
        closeManageInterestsModal();
        closePaywallModal();
        saveInterest();
    }
    
    function saveInterest() {
        $('.js-interest-checkbox').on('click', function (e) {
            var $this = $(this);
            var $checkBoxWrapper = $($this.parent('.js-checkbox-label'));
            if (!$checkBoxWrapper.hasClass('checked')) {
                $checkBoxWrapper.addClass('checked');
            }
            else {
                $checkBoxWrapper.removeClass('checked');
            }
        });
        
        $('.js-alert-checkbox').on('click', function (e) {
            var $this = $(this);
            var $checkBoxWrapper = $($this.parent('.js-alert-checkbox-label'));
            if (!$checkBoxWrapper.hasClass('checked')) {
                $checkBoxWrapper.addClass('checked');
            }
            else {
                $checkBoxWrapper.removeClass('checked');
            }
        });
        
        $('.js-interest-savebutton').on('click', function () {
            let $checkedInputs = $('.js-checkbox-label.checked').find('input.js-interest-checkbox');
            let $alertInputsChecked = $('.js-alert-checkbox-label.checked').find('input.js-alert-checkbox');
            let categoryIds = [];
            let alertScheduleIds = [];
            let ajaxUrl = '/Content/UpdateMyInterest';
            let ajaxData = { categoryIds: categoryIds, alertScheduleIds: alertScheduleIds };

            $successMsgSpan.addClass('hide');
            $errorMsgSpan.addClass('hide');

            $checkedInputs.each(function (_i, v) {
                categoryIds.push($(v).data('catid'));
            });
            
            $alertInputsChecked.each(function(_i, v) {
                alertScheduleIds.push($(v).data('scheduleid'));
            });

            SCM.Ajax.post(ajaxUrl, ajaxData)
                .expectActionResultModel()
                .ensureSuccess()
                .then(_handleAjaxSuccess)
                .catch(_handleAjaxError);

            function _handleAjaxSuccess() {
                $successMsgSpan.removeClass('hide');
            }

            function _handleAjaxError(error) {
                console.error(error);
                $errorMsgSpan.removeClass('hide');
            }
        });
    }

    function _handleModalOpen($modal) {
        $successMsgSpan.addClass('hide');
        $errorMsgSpan.addClass('hide');
        $body.addClass('on-canvas');
        SCM.Utilities.Reveal.open($modal);
        SCM.Focus.trap($modal);
    }

    function _handleModalClose($modal) {
        SCM.Utilities.Reveal.close($modal);
        SCM.Focus.release($modal);
        $body.removeClass('on-canvas');
    }

    function openManageInterestsModal() {
        $('.manage-interests-link').on('click', function () {
            _handleModalOpen($interestsModal);
        });
    }

    function openPaywallModal() {
        $('.manage-interests-link-no-access').on('click', function () {
            _handleModalOpen($noAccessModal);
        });
    }

    function closeManageInterestsModal() {
        $('.js-interests-modal-close').on('click', function () {
            _handleModalClose($interestsModal);
        });
    }

    function closePaywallModal() {
        $('.js-login-modal-close').on('click', function () {
            _handleModalClose($noAccessModal);
        });
    }

})(jQuery);